/* eslint-disable @typescript-eslint/no-explicit-any */
export const INTERNAL_PO_IDS = {
    Enfusion: 64320,
    Demo: 449926,
    DemoAM: 633431,
    QA: 539240,
};
export const EMPTY_ARRAY = [];
export const EMPTY_RECORD = {};
export const LANDING_REDIRECT_KEY = "es-lrk";
export const FACTSET_LOADED_KEY = "es-fsl";
export const BSSO_TOKEN_KEY = "es-bsso-t";
export const BSSO_REDIRECT_KEY = "es-bsso-r";
export const THEME_KEY = "es-theme";
export const APP_TYPE_COOKIE_NAME = "XAPPTYPE";
export const DASHBOARD_LATEST_CONFIG_VERSION = 2;
export const PORTFOLIO_LATEST_CONFIG_VERSION = 1;
export var GoogleAnalyticsCustomFields;
(function (GoogleAnalyticsCustomFields) {
    GoogleAnalyticsCustomFields["UserId"] = "dimension1";
    GoogleAnalyticsCustomFields["PO"] = "dimension2";
    GoogleAnalyticsCustomFields["AppId"] = "dimension3";
    GoogleAnalyticsCustomFields["AppVersion"] = "dimension4";
})(GoogleAnalyticsCustomFields || (GoogleAnalyticsCustomFields = {}));
export const UNKNOWN_INSTRUMENT_ID = 1195120;
export const UNKNOWN_INSTRUMENT_SEARCH_RESULT = {
    exchangeId: 2,
    ticker: "_UNKNOWN",
    countryCode: "Unknown",
    quotationFormat: "Price4",
    description: "Unknown",
    exchangeShortname: "Unknown",
    subType: "Equity",
    exchangeName: "Unknown",
    id: 1195120,
    currencyId: 231,
    currencyCode: "USD",
    countryId: 0,
};
export const UNKNOWN_INSTRUMENT_INFO = {
    id: 1195120,
    processingOrgId: 1,
    description: "Unknown",
    financialSubType: {
        description: "Equity",
        parent: "Equity",
    },
    priceDivisor: 1,
    restricted: false,
    quoteType: "Price",
    quotationFormat: "Price4",
    keywords: [
        {
            name: "TICKER",
            value: "_UNKNOWN",
        },
    ],
    tickSize: 0.01,
    lotSize: 0,
    currency: {
        id: 231,
        code: "USD",
        description: "US Dollar",
        deliverable: true,
        crypto: false,
        parentCurrencyId: 0,
        parentConversionFactor: 1,
    },
    exchange: {
        id: 2,
        shortName: "Unknown",
        name: "Unknown",
        country: {
            id: 0,
            code: "Unknown",
        },
        keywords: [
            {
                name: "MARKIT_ENTITY_NAME",
                value: "IOI Corp BHD",
            },
            {
                name: "UK_TAKOVER_OFFEREE",
                value: "true",
            },
            {
                name: "PIABLACKROCK_BROKER_CODE",
                value: "Unspecified",
            },
            {
                name: "REF_ENTITY_RED",
                value: "YC58D9",
            },
            {
                name: "CITCO_BROKER_CODE",
                value: "ZZ-INTRL",
            },
            {
                name: "BARCLAYS_BROKER_CODE",
                value: "Unknown",
            },
            {
                name: "MIC_CODE",
                value: "UNKW",
            },
        ],
        Links: [],
    },
    Links: [],
};
